.box {
  position: relative;
  background: var(--color-bg-raised);
  border: var(--border-width-2) var(--border-style) var(--color-border);
  box-shadow: var(--shadow-pixel-md);
  padding: var(--space-5);
  /* Inset double-border using a hard pixel inner shadow — gives the chunky RPG dialog feel. */
  box-shadow: var(--shadow-pixel-md), inset 0 0 0 var(--border-width-1) var(--color-bg);
}

.tone_accent {
  border-color: var(--color-accent);
  box-shadow: var(--shadow-pixel-accent),
    inset 0 0 0 var(--border-width-1) var(--color-bg);
}

.tone_magenta {
  border-color: var(--color-magenta);
  box-shadow: var(--shadow-pixel-magenta),
    inset 0 0 0 var(--border-width-1) var(--color-bg);
}

.titleTab {
  position: absolute;
  top: calc(-1 * (var(--space-3) + var(--border-width-2)));
  left: var(--space-4);
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-3);
  background: var(--color-bg);
  border: var(--border-width-2) var(--border-style) var(--color-border);
  font-family: var(--font-display);
  font-size: 0.625rem; /* 10px */
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-accent);
  text-transform: uppercase;
}

.tone_accent .titleTab {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.tone_magenta .titleTab {
  border-color: var(--color-magenta);
  color: var(--color-magenta);
}

.titleBracket {
  color: var(--color-fg-muted);
}

.titleText {
  white-space: nowrap;
}

.body {
  position: relative;
}

.eyebrow {
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg-muted);
  text-transform: uppercase;
  margin-bottom: var(--space-3);
}

@media (max-width: 540px) {
  .box {
    padding: var(--space-4);
  }
}
